import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { useAuth } from "@/contexts/AuthProvider";
import { useNavigate } from "react-router-dom"
import { labelSingularLower } from "@/utils/copyTituloBilhete"

export interface DialogNavegarProps {
    exibir: boolean,
    toggleDialog: () => void
}

export function DialogNavegarPosPagamentoPix({ exibir, toggleDialog }: DialogNavegarProps) {
    const navigate = useNavigate();
    const { atualizarSaldoDisponivel } = useAuth();

    return (
        <AlertDialog open={exibir}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle className="text-2xl text-primary-foreground">
                        Você já realizou o pagamento?
                    </AlertDialogTitle>
                    <AlertDialogDescription>
                        {`Você será redirecionado para a tela de Ultimas Compras para visualizar seu ${labelSingularLower()}`}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <Button onClick={() => {
                        atualizarSaldoDisponivel();
                        navigate('/compra/extrato-compras')
                    }}>Sim</Button>
                    <Button variant='destructive' onClick={toggleDialog}>Não</Button>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}